/* import __COLOCATED_TEMPLATE__ from './payoneer-setup.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import config from 'sh-www/config/environment';

const CLASS_NAME = 'SH-c-payout-add-method-payoneer-setup';

export default Component.extend({
  classNames: [CLASS_NAME, 'LSG-l-grid', 'justify-center'],
  CLASS_NAME,

  get cloudinaryCloudName() {
    return config.cloudinary.cloudName;
  },

  /** @param {PayoutAccount|null} */
  payoutAccount: null,

  /** @param {Function} */
  onCreatePayoutAccount: () => {},

  /** @param {Function} */
  onOpenPayoneer: () => {},

  /** @param {Boolean} */
  isLoading: false,

  payoneerLogoUrl: computed(
    'cloudinaryCloudName',
    function () {
      return `https://res.cloudinary.com/${this.cloudinaryCloudName}/image/upload/h_32/v1/web/icons/Payoneer_Master_Logo_OnWhite_RGB.svg`;
    }
  ),

  actions: {
    handleContinue() {
      this.get('payoutAccount')
        ? this.get('onOpenPayoneer')()
        : this.get('onCreatePayoutAccount')();
    },
  },
});
